import { formatCount } from '@saay/formatting';

import type { AdminMerchant } from './api.js';

/** Persian reason when «بستن فروشگاه» must stay disabled (ADM-20). */
export function merchantCloseBlockedReason(
  readiness: AdminMerchant['closureReadiness'],
): string | undefined {
  if (readiness.canClose) {
    return undefined;
  }
  if (readiness.closeBlockers.includes('PENDING_SETTLEMENTS')) {
    return `${formatCount(readiness.pendingSettlementCount)} تسویهٔ باقی‌مانده`;
  }
  return 'بستن فروشگاه ممکن نیست';
}
